import { requestActions } from "./utils";

export const COMPANY = requestActions("Company/Get");
export const COMPANY_UPDATE = requestActions("Company/Update");
